"use client"

import { emptyTokenAndSelectionMetadata } from "@/actions/cookies/centraDefaultSessionFromCookies"
import { RequiredTokenAndSelectionMetadata } from "@/types/cookie-types"

//@todo: see if this is really needed, maybe instead use the useCentraSession hook
export const getCentraSessionFromCookiesClient =
    async (): Promise<RequiredTokenAndSelectionMetadata | null> => {
        const res = await fetch("/api/get-centra-session-from-cookies", {
            method: "POST",
            credentials: "include" // ensures cookies are sent
        })
        if (!res.ok) return emptyTokenAndSelectionMetadata //maybe null instead?
        return await res.json()
    }
